import React, { useContext, useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import Loading from "../containers/Loading";
import { AuthContext } from "../auths/Auth";
import CommonLayout from "../layouts/private/CommonLayout";
import { checkHasPermission } from "@/helpers/checkHasPermission";

const PrivateRoute = ({ component: Component, ...props }) => {
  // Declare the useContext() so this component will have the same context as AuthContext.Provider
  const { isAuthenticated, isLoading, checkAuth, isLoginFailed } =
    useContext(AuthContext);
  const permissionName = props.permissionName;
  const showToolBar = props.showToolBar;
  const [isPermitted, setIsPermitted] = useState(
    !permissionName ? true : false
  );

  const checkIsPermitted = permissionName => {
    // check if the user is permitted
    if (!permissionName) return true;
    setIsPermitted(checkHasPermission(permissionName));
  };

  useEffect(() => {
    checkAuth("PrivateRoute");
    if (isAuthenticated) {
      checkIsPermitted(permissionName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, permissionName]);

  return (
    <Route
      {...props}
      render={props =>
        !isLoading ? (
          isAuthenticated ? (
            isPermitted ? (
              <CommonLayout showToolBar={showToolBar}>
                <Component {...props} />
              </CommonLayout>
            ) : (
              ( <Redirect to="/groups/groups-devices" />)
            )
          ) : isLoginFailed ? (
            <Redirect to="/login-error" />
          ) : (
            <Redirect to="/login" />
          )
        ) : (
          <Loading />
        )
      }
      name={props.permissionName}
    />
  );
};

export default PrivateRoute;
